// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"676d58e2","285":"17803a7a","320":"25ccfee6","480":"676d58e2","529":"e4e2561d","530":"676d58e2","606":"e0b4c408","621":"9546958b","661":"676d58e2","680":"676d58e2","716":"bb38e9c2","798":"676d58e2","828":"676d58e2","865":"676d58e2","925":"9546958b"}[chunkId] + ".chunk.css";
};